


































import Vue from 'vue'
import AppLayout from '@rhitics/vue/components/AppLayout.vue'

export default Vue.extend({

  name: 'Account',

  components: {
    AppLayout
  },

  data() {
    return {
      navigation: {
        basic: {
          path: '/account/basic',
          icon: 'fas fa-user',
          name: this.$t('core.navigation.account_basic')
        },
        pref: {
          path: '/account/preference',
          icon: 'fas fa-cog',
          name: this.$t('core.navigation.account_preference')
        }
      }
    }
  }
})
